import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { ModalService } from '../../../core/services/modal.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { DocPackTypeSubmitEvent } from '../doc-pack-type/doc-pack-type.component';

@Component({
    selector: 'tt-doc-pack-type-menu',
    templateUrl: './doc-pack-type-menu.component.html',
    styleUrls: ['./doc-pack-type-menu.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocPackTypeMenuComponent implements OnInit {
    docPackTypeKeyno;

    public menu?: Menu;

    public grid?: GridOptions;

    public documentationPackTypeNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'docpacktype', gotoParms: () => this.menu!.docpacktype_keyno ?? '' }];

    public deleting = false;

    constructor(
        private stateService: StateService,
        private modal: ModalService,
        private datatask: DataTaskService,
        private cdr: ChangeDetectorRef,
    ) {
        this.docPackTypeKeyno = this.stateService.getStateParams()['docpacktype_keyno'];
    }

    private async loadMenu() {
        if (!!this.docPackTypeKeyno) {
            this.menu = (await this.datatask.Post(3284, { docpacktype_keyno: this.docPackTypeKeyno }))[0];
            this.cdr.markForCheck();
        }
    }

    private createGrid() {
        if (!!this.menu?.docpacktype_keyno) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('docpacktypechapter_grid')
                    .setLoadDataFunction({
                        method: 3278,
                        parameters: { docpacktype_keyno: this.menu.docpacktype_keyno },
                    })
                    .setKendoConfig({ height: '100%' })
                    .setCustomToolbarButtons([
                        {
                            name: 'docpacktypemenu_new_chapter',
                            text: 'docpacktypemenu_new_chapter',
                            func: () =>
                                this.stateService?.go('docpacktypechapter', {
                                    docpacktype_keyno: this.menu?.docpacktype_keyno,
                                    docpacktypechapter_keyno: '0',
                                }),
                            icon: 'fas fa-plus',
                            cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                            translate: true,
                        },
                    ]);
            }
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger',
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(3287, this.menu))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage,
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public onDocPackTypeSubmit(event: DocPackTypeSubmitEvent) {
        if (event.type === 'delete') {
            this.stateService.back();
        }
    }

    private async init() {
        await this.loadMenu();
        this.createGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    docpacktype_keyno: string;
    docpacktype_name: string;
    reg_datetime: string;
    reg_by_portal_user_name: string;
    tab: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('docPackTypeMenu', {
//        templateUrl: 'views/components/views/docPackTypeMenu/docPackTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'docPackTypeMenuService', 'ttGridFactory', function ($stateParams, stateService, modalService, translateService, docPackTypeMenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let docPackTypeKeyno = $stateParams.docpacktype_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                documentationPackTypeNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('docpacktype', { docpacktype_keyno: vm.model.menu.docpacktype_keyno }) }
//                ],
//                menu: {},
//                gridReady: false,
//                lockedDelete: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'docpacktypechapter_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'docpacktypemenu_new_chapter',
//                text: 'docpacktypemenu_new_chapter',
//                func: () => {
//                    stateService.go('docpacktypechapter', {
//                        docpacktype_keyno: vm.model.menu.docpacktype_keyno,
//                        docpacktypechapter_keyno: '0'
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await docPackTypeMenuService.getMenu({ docpacktype_keyno: docPackTypeKeyno }))[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3278,
//                    parameters: { docpacktype_keyno: vm.model.menu.docpacktype_keyno }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    docPackTypeMenuService.deleteItem(vm.model.menu).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
